<template>
  <v-menu :close-on-click="!touring" :close-on-content-click="false" offset-y>
    <template #activator="{ on, attrs, value }">
      <v-btn
        v-tooltip="$t('tooltip.appBar.account')"
        class="c-adjustment"
        :class="activatorClass"
        :data-title="$t('tour.appBar.accountMenu.title')"
        :data-intro="$t('tour.appBar.accountMenu.intro')"
        :data-toggle="value ? 'nop' : 'open'"
        fab
        small
        v-bind="attrs"
        v-on="on"
        @click.stop
      >
        <v-avatar class=c-avatar size="40">
          <v-img v-if="isAuthenticated" :src="avatarURL" />
          <v-icon v-else color="accent" large> mdi-account </v-icon>
        </v-avatar>

      </v-btn>
    </template>

    <!-- menu items -->
    <v-list class="c-menu-items" rounded>
      <UserMenuItem />

      <v-divider />

      <LocaleMenuItem />
      <ModeMenuItem />
      <SettingsMenuItem />
      <SignInOutMenuItem  />
    </v-list>
  </v-menu>
</template>

<script>
import UserMenuItem from '@/components/account/UserMenuItem'
import LocaleMenuItem from '@/components/account/LocaleMenuItem'
import ModeMenuItem from '@/components/account/ModeMenuItem'
import SettingsMenuItem from '@/components/account/SettingsMenuItem'
import SignInOutMenuItem from '@/components/account/SignInOutMenuItem'

export default {
  name: 'AccountMenu',

  components: {
    UserMenuItem,
    LocaleMenuItem,
    ModeMenuItem,
    SettingsMenuItem,
    SignInOutMenuItem
  },

  props: {
    activatorClass: {
      type: String,
      required: false,
      default: ''
    }
  },

  data: function () {
    return {
      avatarURL: '',
      isAuthenticated: false,
      touring: false
    }
  },

  mounted: function () {
    this.avatarURL = this.$auth.getUserAvatar()
    this.isAuthenticated = this.$auth.isAuthenticated()
  },

  activated: function () {
    this.avatarURL = this.$auth.getUserAvatar()
    this.isAuthenticated = this.$auth.isAuthenticated()
  },

  methods: {}
}
</script>

<style lang="css" scoped>
.c-menu-items :deep(.v-list-item__action) {
  margin-right: 8px;
  min-width: unset;
}
.c-menu-items :deep(.v-list-item) {
  padding: 0px 8px;
}

.c-adjustment {
  margin-bottom: 1px;
}

.c-avatar {
  outline: var(--v-text-base) 1px solid;
}

.c-list-group .v-list-item--active.theme--dark {
  color: white !important;
}
.c-list-group .v-list-item--active.theme--light {
  color: black !important;
}
</style>
